import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ForgotPasswordRequest } from '@dto/forgotPasswordRequest';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ForgotPasswordSuccessComponent } from '../forgot-password-success/forgot-password-success.component';
import { MessageService } from '@services/message/message.service';
import '@angular/localize/init';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  public forgotPasswordForm: UntypedFormGroup

  private _returnUrl: string;
  
  public whitelabel: string
  public whitelabelURL: string = 'https://cubosgeneralstorage.blob.core.windows.net/whitelabel-storage/'

  currentYearLong(): number {
    return new Date().getFullYear();
  }

  constructor(@Inject('BASE_URL') private baseUrl: string,
    private authenticationService: AuthenticationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public messageService: MessageService) { }

  ngOnInit(): void {
    this.forgotPasswordForm = new UntypedFormGroup({
      email: new UntypedFormControl("", [Validators.required])
    })
  }
  
  ngAfterViewInit() {
    this.whitelabel = localStorage.getItem('whitelabel')
  }

  validateControl(controlName: string) {
    return this.forgotPasswordForm.controls[controlName].invalid && this.forgotPasswordForm.controls[controlName].touched
  }

  hasError(controlName: string, errorName: string) {
    return this.forgotPasswordForm.controls[controlName].hasError(errorName)
  }

  forgotPassword(forgotPasswordFormValue) {
    const forgotPass = { ...forgotPasswordFormValue };

    const forgotPasswordRequest: ForgotPasswordRequest = {
      email: forgotPass.email,
      clientURI: this.baseUrl + 'auth/resetpassword' 
    }

    this.authenticationService.forgotPassword(forgotPasswordRequest)
      .subscribe(result => {
        this.messageService.setSuccess($localize`:@@LinkHasBeenSendMessage:The link has been sent, please check your email to reset your password.`)
        this.router.navigate(['auth/forgotpasswordsuccess']);
      }, error => {
        this.messageService.setError(error);
        this.router.navigate(['auth/forgotpasswordsuccess']);
      })
  }

}
